import { USER_COLLAPSE, USER_EXPAND } from 'common/actions/row-groups/types';
import { PREFERENCES_FALLBACK_STORAGE_PREFIX } from './preferencesIndexedDB.constants';

export const getPreferenceFallbackKey = (key: string): string =>
  `${PREFERENCES_FALLBACK_STORAGE_PREFIX}${key}`;

export const isPreferenceQuotaError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false;
  }
  const domError = error as DOMException;
  return (
    domError.name === 'QuotaExceededError' ||
    domError.code === 22 ||
    domError.code === 1014
  );
};

const isRowPreferenceValue = (value: unknown): boolean =>
  value === USER_EXPAND || value === USER_COLLAPSE;

// Legacy cap-table blob stored row aliases at the root with no user-id wrapper.
export const isFlatCapTableRowGroupPrefs = (prefs: Record<string, unknown>): boolean =>
  Object.values(prefs).some(isRowPreferenceValue);

// Legacy blob keyed by cap table id -> row prefs with no user-id wrapper.
export const isNestedCapTableRowGroupPrefs = (prefs: Record<string, unknown>): boolean => {
  const values = Object.values(prefs);
  if (values.length === 0) {
    return false;
  }
  return values.every(
    value =>
      value !== null &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      isFlatCapTableRowGroupPrefs(value as Record<string, unknown>)
  );
};

export const isNumericKey = (key: string): boolean => /^\d+$/.test(key);
